<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class="formItemBox">
            <el-form-item label="运单编号:">
              <el-input  placeholder="" v-model="searchFrom.wayNo"></el-input>
            </el-form-item>
            <el-form-item label="异常类型 :">
              <el-select v-model="searchFrom.exceptionType" placeholder="请选择">
                <el-option v-for="val in yclx" :label="val.name" :value="val.val" :key="val.val"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="车辆号牌:">
              <el-input  placeholder="" v-model="searchFrom.plateNumber"></el-input>
            </el-form-item>
            <el-form-item label="司机姓名:">
              <el-input  placeholder="" v-model="searchFrom.driverName"></el-input>
            </el-form-item>
            <el-form-item label="上报时间:">
              <el-date-picker
                v-model="reportDateTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :default-time="['00:00:00', '23:59:59']"
              ></el-date-picker>
            </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item btnCode="009M0I0100">
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item btnCode="009M0I0200">
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <!-- <el-form-item btnCode="009M0I0300">
            <el-button type="primary" @click="exportFn" :disabled="isDisable">导出</el-button>
          </el-form-item> -->
        </div>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" @row-click="handleRowClick"    bordersize="mini" class="tableComent" height="100%" style="width: 100%" center border >
        <el-table-column label="操作"  width="100">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" @click="lookImage(scope.row)">查看图片</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column fixed type="index"  width="55" label="序号"></el-table-column>
        <el-table-column prop="wayNo" width="230" label="运单号"></el-table-column>
        <el-table-column prop="exceptionType" width="120" :formatter="emptyFn" label="异常类型">
          <template scope="scope">
            <span v-show="scope.row.exceptionType == '1'">堵车</span>
            <span v-show="scope.row.exceptionType == '2'">车辆故障</span>
            <span v-show="scope.row.exceptionType == '3'">天气异常</span>
            <span v-show="scope.row.exceptionType == '4'">交通事故</span>
            <span v-show="scope.row.exceptionType == '5'">其他</span>
          </template>
        </el-table-column>
        <el-table-column prop="exceptionDescribe" width="230" :formatter="emptyFn" label="异常信息" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="plateNumber" width="130" :formatter="emptyFn" label="车牌号"></el-table-column>
        <el-table-column prop="driverName" width="130" :formatter="emptyFn" label="司机姓名"></el-table-column>
        <el-table-column prop="driverPhone" width="130" :formatter="emptyFn" label="司机电话"></el-table-column>
        <el-table-column prop="address" width="" :formatter="emptyFn" label="上报位置" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="createTime" width="170" label="上报时间" :formatter="dateTimeFormat"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog title="查看图片" :close-on-click-modal="false" :visible.sync="addMarkLookBox" width="50%" center>
      <div v-if="imgData.length == 0" class="noImg">暂无图片</div>
      <div class="img_box" v-for="(item,index) in imgList" :key="index">
        <el-image :src="item" :preview-src-list="getSrcList(index)" class="tupian" ></el-image>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { exceptionList, exceptionGetImage } from '@/api/newTMS'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      isDisable: false,
      emptyFn: emptyFn,
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      total: 0,
      loading: false,
      yclx: [
        { val: '', name: '全部' },
        { val: '1', name: '堵车' },
        { val: '2', name: '车辆故障' },
        { val: '3', name: '天气异常' },
        { val: '4', name: '交通事故' },
        { val: '5', name: '其他' }
      ],
      btnFlg: [],
      btnIdArr: ['009M0I0100', '009M0I0200', '009M0I0300'],
      reportDateTime: [],
      addMarkLookBox: false,
      imgData: [],
      imgList: []
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/unusual')
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 166) + 'px'
  },
  methods: {
    // 点击图片放大
    getSrcList (index) {
      return this.imgList.slice(index).concat(this.imgList.slice(0, index))
    },
    // 导出
    exportFn () {
      this.searchFrom.reportTimeStart = this.reportDateTime[0]
      this.searchFrom.reportTimeEnd = this.reportDateTime[1]
      let form = this.searchFrom
      exportExcel(
        this.global.orderName + '/exceptionReporting/exportInventoryList',
        form,
        '异常风险列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 获取货物列表
    getList (searchFrom) {
      this.loading = true
      this.searchFrom.startTime = this.reportDateTime[0]
      this.searchFrom.endTime = this.reportDateTime[1]
      exceptionList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      this.reportDateTime = []
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    },
    lookImage (row) {
      this.addMarkLookBox = true
      exceptionGetImage({
        id: row.id
      }).then(res => {
        this.imgList = []
        this.imgData = res
        this.imgList = res.map(item => item.fileKeyUrl)
      })
        .catch(error => {
          this.$message.error(error.message)
        })
    }
  }
}
</script>
<style scoped lang='less'>
/deep/.el-form{
  width: 100%;
}

.imgBox{
  margin: 22px 10px;
  ul{
    display: flex;
    padding-left: 0;
    li{
      width: 160px;
      height: 160px;
      list-style: none;
      margin-right: 10px;
      img{
        width:100%;
        height:100%
      }
    }
  }
 }
.hidden /deep/.el-upload--picture-card{
  display: none;
}
.hidden /deep/.el-upload--picture-card{
  display: none;
}
.img_box {
  width: 200px;
  height: 200px;
  display: inline-block;
  margin-right: 20px;
  // border: 1px dashed #ccc;
  padding: 5px;
  .tupian {
    width:100%;
    height: 100%;
    // max-width:100%;
    // object-fit:none;/*保留原有元素内容的长度和宽度*/
  }
}
</style>
